// Lê a variante de tema ativa (--mexx-* / --status-*, carregadas pelo components/theme/ThemeLoader.jsx)
// para que gráficos recharts acompanhem a cor do whitelabel em vez de usar hex fixo.
const FALLBACK = {
  primary: '#8BC34A',
  primaryDark: '#689F38',
  primaryLight: '#C8E6C9',
  primaryHover: '#9CCC65',
  success: '#8BC34A',
  warning: '#FF9800',
  error: '#F44336',
  info: '#2196F3',
  neutral: '#9E9E9E',
  textPrimary: '#212121',
  textSecondary: '#757575',
  gridLine: '#E0E0E0',
};

const readVar = (name, fallback) => {
  if (typeof window === 'undefined' || typeof document === 'undefined')
    return fallback;
  const value = getComputedStyle(document.documentElement).getPropertyValue(name);
  return value && value.trim() !== '' ? value.trim() : fallback;
};

export const getChartColors = () => {
  const theme = {
    primary: readVar('--mexx-green-primary', FALLBACK.primary),
    primaryDark: readVar('--mexx-green-dark', FALLBACK.primaryDark),
    primaryLight: readVar('--mexx-green-light', FALLBACK.primaryLight),
    primaryHover: readVar('--mexx-green-hover', FALLBACK.primaryHover),
    success: readVar('--status-success', FALLBACK.success),
    warning: readVar('--status-warning', FALLBACK.warning),
    error: readVar('--status-error', FALLBACK.error),
    info: readVar('--status-info', FALLBACK.info),
    neutral: readVar('--status-neutral', FALLBACK.neutral),
    // Roxo puramente decorativo (sem token de tema equivalente ainda) — só pra dar mais
    // variedade a paletas categóricas com muitos itens (ex.: 5 KPIs), igual outras cores
    // "categorical" que também não carregam significado de marca.
    accentPurple: readVar('--mexx-accent-purple', '#8E6FCE'),
    textPrimary: readVar('--mexx-gray-800', FALLBACK.textPrimary),
    textSecondary: readVar('--mexx-gray-600', FALLBACK.textSecondary),
    gridLine: readVar('--mexx-gray-300', FALLBACK.gridLine),
  };

  theme.categorical = [
    theme.primary,
    theme.info,
    theme.warning,
    theme.error,
    theme.primaryDark,
    theme.neutral,
  ];

  return theme;
};

// Clareia uma cor hex pra usar como fundo "pastel" de selo/badge (estilo emprestado do novo
// padrão visual de dashboards) sem precisar de um token de tema novo pra cada cor de destaque.
export const withAlpha = (hex, alpha) => {
  if (typeof hex !== 'string' || hex.charAt(0) !== '#') return hex;
  const clean = hex.slice(1);
  const full = clean.length === 3 ? clean.split('').map(c => c + c).join('') : clean;
  const int = parseInt(full, 16);
  if (Number.isNaN(int)) return hex;
  const r = (int >> 16) & 255;
  const g = (int >> 8) & 255;
  const b = int & 255;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export default getChartColors;
